/// <amd-module name="Environments/Providers/Kubernetes/Constants" />
export namespace HyperLinks {
  export const ResourceDeletedLink = "https://go.microsoft.com/fwlink/?linkid=2083857";
  export const ResourceAccessDeniedLink = "https://go.microsoft.com/fwlink/?linkid=2083857";
}

export namespace ImageServiceConstants{
    export const ImageProvenanceArea = "ImageProvenace";
    export const ImageProvenanceAPIInvokedFeature = "ImageProvenanceAPIInvokedFeature";
    export const K8sSummaryImageServiceSource = "k8sSummaryImageService";
    export const TelemeterySourceKey = "source";
}
